import { MappedPoseidonReportDataModel } from '@models/ReportModel';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { EventDetailsCard } from './EventDetailsCard';
import { useTransformDrinkingEventToReport } from '../hooks/useTransformDrinkingEventToReport';
import useBoundStore from '../../../store/store';

interface DrinkingPointReportProps {
  data: MappedPoseidonReportDataModel;
}

export const DrinkingEventReport = ({ data }: DrinkingPointReportProps) => {
  const { t } = useTranslation();
  const item = useTransformDrinkingEventToReport(data);
  const { getDeviceById } = useBoundStore((s) => s.deviceStore);

  item.duration = data.duration < 60 ? `00:${item.duration}` : item.duration;

  return (
    <EventDetailsCard
      leftLabel={t('time')}
      leftValue={item.time}
      centerLabel={t('amount')}
      centerValue={item.amount}
      rightLabel={t('duration')}
      rightValue={item.duration}
      multiPetEvent={!!item.multi}
      multiPetLabel={t('multiple_pets_drank')}
      deviceName={getDeviceById(data.device_id)?.name || ''}
    />
  );
};
